import { LoaderFunctionArgs } from 'react-router-dom';

import { assertPresence } from '../../lib/runtime';
import { parseSearchParams } from '../../lib/url';
import { loadCountryOptions } from '../../queries/form-data';
import { loadAdminRewards, loadCatalogSettings, loadCollection, loadCollectionItems, loadCollections } from '../../queries/rewards';
import { getManageItemsParamsFromUrl } from './manage-items/hooks';
import { createCollectionParamParser } from './utils';

export const loadSettings = () => loadCatalogSettings();
export const loadIndex = () => Promise.all([loadCollections(), loadCatalogSettings()]);

export const loadCollectionDetail = async ({ params, request }: LoaderFunctionArgs) => {
	const { id } = params;
	const searchParams = new URL(request.url).searchParams;
	const queryParams = parseSearchParams(searchParams, ...createCollectionParamParser());
	assertPresence(id);
	const [collection] = await Promise.all([loadCollection(id), loadCountryOptions(), loadCatalogSettings()]);

	return loadCollectionItems(collection.id, queryParams);
};

export const loadItems = async ({ request }: LoaderFunctionArgs) => {
	const url = new URL(request.url);
	const params = getManageItemsParamsFromUrl(url.search);

	// Preload country options before fetching admin rewards
	await loadCountryOptions();

	return loadAdminRewards(params);
};
